<template>
<m-pageframe
    title="{organization_label}: CTIA Keywords"
>
<v-container
    v-if="settings != null"
>
    <v-alert
        v-if="!can_edit && this.$rc.isAuthActorSystemAdmin()"
        border="left"
        colored-border
        color="primary"
        elevation="2"
        type="warning"
    >
        RedChirp staff cannot modify CTIA keyword responses for non-demo organizations
    </v-alert>

    <v-alert
        v-if="!can_edit && !this.$rc.isAuthActorSystemAdmin()"
        border="left"
        colored-border
        color="primary"
        elevation="2"
        type="info"
    >
        Only Organization Admins can edit CTIA keyword responses
    </v-alert>

    <v-alert
        v-if="can_edit"
        border="left"
        colored-border
        color="primary"
        elevation="2"
        type="info"
    >
        Be careful when customizing these responses. Please refer to the <a href="https://api.ctia.org/wp-content/uploads/2023/05/230523-CTIA-Messaging-Principles-and-Best-Practices-FINAL.pdf" target="_blank">CTIA Messaging Principles and Best Practices</a> when drafting your messages.
    </v-alert>

    <div
        class="section-header"
    >
        Opt-Out Responses
    </div>

    <v-text-field
        label="Keywords"
        :value="'CANCEL, END, QUIT, STOP, STOPALL, UNSUBSCRIBE'"
        disabled
    />

    <m-edit-message-patterns-compact
        label="Opt-Out Message Patterns"
        v-model="settings.stop_response_patterns"
        context="ctia-keyword-auto-response"
        v-on:input="put"
        v-bind:disabled="!can_edit"
    />


    <div
        class="section-header"
    >
        Opt-In Responses
    </div>

    <v-text-field
        label="Keywords"
        :value="'START, UNSTOP, YES'"
        disabled
    />

    <m-edit-message-patterns-compact
        label="Opt-Out Message Patterns"
        v-model="settings.start_response_patterns"
        context="ctia-keyword-auto-response"
        v-on:input="put"
        v-bind:disabled="!can_edit"
    />


    <div
        class="section-header"
    >
        Help Responses
    </div>

    <v-text-field
        label="Keywords"
        :value="'HELP'"
        disabled
    />

    <m-edit-message-patterns-compact
        label="Help Message Patterns"
        v-model="settings.help_response_patterns"
        context="ctia-keyword-auto-response"
        v-on:input="put"
        v-bind:disabled="!can_edit"
    />

    <div
        style="text-align: right; margin-top: 24px;"
    >
        <v-btn
            v-on:click="onClickResetToDefaults"
        >
            Reset to RedChirp Default Responses...
        </v-btn>
    </div>

    <p
        style="font-size: 12px; margin-top: 7px; text-align: right;"
    >
        * &mdash; Want to edit your custom keywords and responses? Go <a v-on:click="linkToCustomKeywordSettings">here</a>.
    </p>

</v-container>
</m-pageframe>
</template>

<style>
div.section-header {
    margin-top: 24px;
    margin-bottom: 6px;
    font-weight: bold;
}
</style>

<script>
const _ = require('lodash');

export default
{
    data()
    {
        return {
            settings: null,
            can_edit: false
        }
    },

    mounted ()
    {
        this.update();

        // Only editable by org admins
        if (this.$rc.$state.isOrganizationAdmin())
        {
            if (this.$rc.isAuthActorSystemAdmin())
            {
                // Staff can only edit demo orgs, NOT customer orgs
                if (this.$rc.$state.isDemoOrTestOrganization() || this.$rc.ORG_ID_RED_CHIRP == this.settings.organization_id)
                {
                    this.can_edit = true;
                }
            }
            else
            {
                // Regular organization admin
                this.can_edit = true;
            }
        }
    },

    methods:
    {
        update()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/ctia-keyword-auto-response/settings/:organization_id',
            
                'params' :
                {
                    'organization_id' : this.$route.params.organization_id,
                },
            
                'on_success': (data) =>
                {
                    this.settings = data.settings;
                },
            
                'on_error': 'Unable to complete API call',
            });
        },

        put: _.debounce(function()
        {
            this.$rc.rest(
                'PUT: /api/v1/ctia-keyword-auto-response/settings',
            
                this.settings,
            
                (data) => {},
            
                () =>
                {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },500),

        onClickResetToDefaults()
        {
            this.$rc.confirm({
                'title': 'Warning: Reset CTIA Keyword Responses',
                'body': 'Are you sure you want to reset your CTIA keyword responses to the RedChirp default?<br/>Your customizations will be deleted permanently.',
                'btn_text_ok': 'Reset',
                'btn_text_cancel': 'Cancel',
                'on_ok': () =>
                {
                    this.$rc.rest({
                        'spinner': false,
                        'endpoint': 'DELETE: /api/v1/ctia-keyword-auto-response/settings',
                    
                        'params' :
                        {
                            'organization_id' : this.settings.organization_id,
                        },
                    
                        'on_success': (data) =>
                        {
                            this.update();
                        },
                    
                        'on_error': 'Unable to complete API call',
                    });
                },
            });
        },

        linkToCustomKeywordSettings()
        {
            let route = {
                'name': 'settings-organization-keyword-auto-responses',
                'params' : {
                        'employee_id' : this.$rc.$state.employee_id,
                        'organization_id' : this.$rc.$state.organization_id,
                    },
            };

            this.$rc.navigationClick(this.$router, route, {});
        }
    }
}
</script>

<style lang="scss" scoped>
</style>